<template>

  <div>


    <vx-card>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Nome</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" readonly icon-pack="feather" icon="icon-user" icon-no-border v-model="user.name" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Sobrenome</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" readonly icon-pack="feather" icon="icon-user" icon-no-border v-model="user.lastName" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" readonly icon-pack="feather" icon="icon-mail" icon-no-border v-model="user.email" />
        </div>
      </div>

    </vx-card>

    <vx-card class="mt-4">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Senha</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" type="password" icon-pack="feather" icon="icon-lock" icon-no-border v-model="user.newPassword" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Confirmar Senha</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" type="password" icon-pack="feather" icon="icon-lock" icon-no-border v-model="user.passwordConfirmation" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <vs-button @click="update" class="mr-3 mb-2">Atualizar</vs-button>
        </div>
      </div>

    </vx-card>

  </div>

</template>

<script>
import axios from 'axios';

  export default {
    name: 'Profile',
    props: {
    },
    data () {
      return {
        user: {
          name: null,
          lastName: null,
          email: null,
          newPassword: null,
          passwordConfirmation: null
        },
      }
    },
    watch: {
      page: function () {
        this.refresh();
      }
    },
    beforeMount() {
      this.refresh();
    },
    methods: {
      refresh: function () {
        const url = process.env.VUE_APP_AUTH_API + '/api/v1/users/me';

        axios.get(url)
          .then((response) => {
            this.user = response.data;
          })
      },
      update: function() {
        const url = process.env.VUE_APP_AUTH_API + '/api/v1/users/update-password';

        axios.put(url, this.user)
          .then((response)=>
          {
            this.$vs.notify({color:'success',text: response.data.message });
          });
      }
    }
  }

</script>

<style scoped>

</style>
